import { Typography } from '@spotnana/blocks/src/Typography';
import { IFareComparison, globalTranslationKeys } from 'obt-common';
import { useTranslation } from 'react-i18next';
import { Icon } from '@spotnana/blocks/src/Icon/Icon';

import {
  fare_rules_change_container,
  fare_rules_change_fare_block,
  fare_rules_change_fare_block_new_fare,
  fare_rules_change_fare_block_title,
  fare_rules_change_fare_blocks,
  fare_rules_change_subtext,
  fare_rules_change_fare_block_airport,
} from './styles';
import FareRuleUtas from './FareRuleUtas';

interface IFareRulesChange {
  newFareComparison: IFareComparison;
  isOutOfPolicy: boolean;
}
const { FLIGHTS } = globalTranslationKeys;

function FareRulesChange({ newFareComparison, isOutOfPolicy }: IFareRulesChange) {
  const { t: tFlights } = useTranslation(FLIGHTS);
  const { t: tt } = useTranslation('WEB');

  return (
    <div css={fare_rules_change_container}>
      <div css={fare_rules_change_subtext}>
        <Typography variant="body2">
          {tt(
            'The selected fare for your itinerary is no longer available. Would you like to proceed with this new fare or restart your search?',
          )}
        </Typography>
      </div>
      <div css={fare_rules_change_fare_blocks}>
        <div css={[fare_rules_change_fare_block, fare_rules_change_fare_block_new_fare]}>
          <div css={fare_rules_change_fare_block_title}>
            <Typography variant="body1" kind="medium">
              {tt('New Fare')}
            </Typography>
            {isOutOfPolicy && (
              <>
                <Typography variant="body2" color="disabled">
                  •
                </Typography>
                <Typography variant="body2" color="error">
                  {tt('Out of policy')}
                </Typography>
              </>
            )}
          </div>
          <div css={fare_rules_change_fare_block_title}>
            <Typography variant="body3" color="disabled">
              <div css={fare_rules_change_fare_block_airport}>
                {newFareComparison.departureAirport}
                <Icon name="ArrowRight" title={tt('to')} variant="standalone" />
                {newFareComparison.arrivalAirport}
              </div>
            </Typography>
            <Typography variant="body3" color="disabled">
              •
            </Typography>
            <Typography variant="body3" color="disabled">
              {`${tFlights(newFareComparison.newFare.cabinType)}`}
            </Typography>
          </div>

          <FareRuleUtas utas={newFareComparison.newFare.utas} />
        </div>
        <div css={fare_rules_change_fare_block}>
          <div css={fare_rules_change_fare_block_title}>
            <Typography variant="body1" kind="medium">
              {tt('Old Fare')}
            </Typography>
          </div>
          <div css={fare_rules_change_fare_block_title}>
            <Typography variant="body3" color="disabled">
              <div css={fare_rules_change_fare_block_airport}>
                {newFareComparison.departureAirport}
                <Icon name="ArrowRight" title={tt('To')} variant="standalone" />
                {newFareComparison.arrivalAirport}
              </div>
            </Typography>
            <Typography variant="body3" color="disabled">
              •
            </Typography>
            <Typography variant="body3" color="disabled">
              {`${tFlights(newFareComparison.oldFare.cabinType)}`}
            </Typography>
          </div>

          <FareRuleUtas utas={newFareComparison.oldFare.utas} />
        </div>
      </div>
    </div>
  );
}

export default FareRulesChange;
